export default "__VITE_ASSET__DYMZSmvk__"